<template>
  <figure
    class="bg-icon-download download-informepdf"
    @click="handleClick(params.data)"
    :class="params.data.informepdf === '' ? 'disabled' : ''"
  >
    <i
      class="material-icons icon-download"
      :class="params.data.informepdf === '' ? 'disabled' : ''"
      title="Descarcar Reporte"
    >
      download
    </i>
  </figure>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
  methods: {
    handleClick(params) {
      if (
        params.informepdf === null ||
        params.informepdf === '' ||
        params.informepdf === undefined
      ) {
        this.$snotify.error(
          'Alta ' + params['nombrealtasservicio'] + ' sin documento disponible'
        );
      } else {
        window.open(params.informepdf, '_blank');
      }
    },
  },
});
</script>

<style scoped>
.bg-icon-download {
  display: grid;
  place-items: center;
  cursor: pointer;
}
.bg-icon-download .icon-download {
  width: 28px;
  height: 28px;
  color: #27488e;
}
.download-informepdf.disabled i {
  color: #cccccc;
  cursor: no-drop;
}
</style>
